'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cart = {
	init: function init() {
		(0, _jquery2.default)('.qty .minus').on('click', function () {
			if ((0, _jquery2.default)(this).parent().find('input').val() > 1) {
				(0, _jquery2.default)(this).parent().find('input').val(parseInt((0, _jquery2.default)(this).parent().find('input').val()) - 1);
			}
		});
		(0, _jquery2.default)('.qty .plus').on('click', function () {
			(0, _jquery2.default)(this).parent().find('input').val(parseInt((0, _jquery2.default)(this).parent().find('input').val()) + 1);
		});
	}
};

exports.default = Cart;